import { Flex } from '@chakra-ui/react'
import { useMemo } from 'react'

import { KeyString } from 'types'
import { INSTITUTION_SLUG } from 'constants/system'
import { useCustomFormViewer } from './contexts/CustomFormViewerManager/Provider'
import useValidateCustomFormQuestions from './hooks/useValidateCustomFormQuestions'
import setGambiarra from './utilsGambiarras/setGambiarra'
import CustomFormViewerQuestion from './components/CustomFormViewerQuestion'
// AGSUS
import AdmissãoPadraoAGSUSPrazoDeterminado from './gambiarras/agsus/AdmissãoPadraoAGSUSPrazoDeterminado'
import AtualizacaoDeDadosCadastraisSaudeIndigena from './gambiarras/agsus/AtualizacaoDeDadosCadastraisSaudeIndigena'
import AtualizacaoDeDadosCadastraisSEDE from './gambiarras/agsus/AtualizacaoDeDadosCadastraisSEDE'
import AtualizacoesDosDadosCadastraisMedicos from './gambiarras/agsus/AtualizacoesDosDadosCadastraisMedicos'
import CalculoDeDiariasDoAGSUS from './gambiarras/agsus/CalculoDeDiariasDoAGSUS'
import CancelamentoAlteracaoDeFerias from './gambiarras/agsus/CancelamentoAlteracaoDeFerias'
import CATComunicacaoDeAcidenteDeTrabalho from './gambiarras/agsus/CATComunicacaoDeAcidenteDeTrabalho'
import CompensacaodeHoras from './gambiarras/agsus/CompensacaodeHoras'
import DependentesDoAGSUS from './gambiarras/agsus/DependentesDoAGSUS'
import EnvioDeAtestadoMedico from './gambiarras/agsus/EnvioDeAtestadoMedico'
import EnvioDeAtestadoMedicoSaudeIndigena from './gambiarras/agsus/EnvioDeAtestadoMedicoSaudeIndigena'
import LevantamentoDeStatusVacinal from './gambiarras/agsus/LevantamentoDeStatusVacinal'
import SolicitacaoDeFerias from './gambiarras/agsus/SolicitacaoDeFerias'
import LicencaMaternidadeSaudeIndigena from './gambiarras/agsus/LicencaMaternidadeSaudeIndigena'
import RecessoBolsista from './gambiarras/agsus/RecessoBolsista'
import RegistroDeHoraExtra from './gambiarras/agsus/RegistroDeHoraExtra'
import SolicitacaoDeFeriasAGSUS from './gambiarras/agsus/SolicitacaoDeFeriasAGSUS'
import SolicitacaoDeFeriasAGSUS_Rejeicao from './gambiarras/agsus/SolicitacaoDeFeriasAGSUS_Rejeicao'
import LicencaAcompanhamentoDeFamiliarDoenteEscritorioESaudeIndigena from './gambiarras/agsus/LicencaAcompanhamentoDeFamiliarDoenteEscritorioESaudeIndigena'
import LicencaAcompanhamentoDeFamiliarDoente from './gambiarras/agsus/LicencaAcompanhamentoDeFamiliarDoente'
import LicencaPaternidade from './gambiarras/agsus/LicencaPaternidade'
import LicencaPaternidadeMedicoBolsista from './gambiarras/agsus/LicencaPaternidadeMedicoBolsista'
import LicencaPaternidadeMedicosCLT from './gambiarras/agsus/LicencaPaternidadeMedicosCLT'
import LicencaPaternidadeSaudeIndigenaEEscritoriosRegionais from './gambiarras/agsus/LicencaPaternidadeSaudeIndigenaEEscritoriosRegionais'
import PreContratacaoDSEIeCASAI from './gambiarras/agsus/PreContratacaoDSEIeCASAI'
import LicencaMaternidade from './gambiarras/agsus/LicencaMaternidade'
import SolicitacaoDeGratificacaoPorTitulacaoEspecializacao from './gambiarras/agsus/SolicitacaoDeGratificacaoPorTitulacaoEspecializacao'
import toast from 'utils/toast'

type KeyStringToReactElement = {
  [key: string]: JSX.Element
}

export default function CustomFormsViewer() {
  const { onSubmit, questions, setQuestionErrors, formMethods, formId } = useCustomFormViewer()

  const { validateQuestionValues } = useValidateCustomFormQuestions()

  const RenderComponentGambiarraByFormId = useMemo(() => {
    if (INSTITUTION_SLUG == 'agsus') {
      const possibleComponents: KeyStringToReactElement = {
        '1000000047': <EnvioDeAtestadoMedico />,
        '1000000048': <LicencaMaternidade />,
        '1000000049': <LicencaPaternidade />,
        '1000000052': <LicencaAcompanhamentoDeFamiliarDoente />,
        '1000000054': <SolicitacaoDeFerias />,
        '1000000060': <RecessoBolsista />,
        '1000000065': <LicencaMaternidadeSaudeIndigena />,
        '1000000077': <SolicitacaoDeFeriasAGSUS />,
        '1000000078': <SolicitacaoDeFeriasAGSUS_Rejeicao />,
        '1000000105': <LicencaAcompanhamentoDeFamiliarDoenteEscritorioESaudeIndigena />,
        '1000000139': <EnvioDeAtestadoMedicoSaudeIndigena />,
        '1000000142': <LicencaPaternidadeMedicosCLT />,
        '1000000145': <LicencaPaternidadeSaudeIndigenaEEscritoriosRegionais />,
        '1000000148': <LicencaPaternidadeMedicoBolsista />,
        '1000000154': <PreContratacaoDSEIeCASAI />,
        '1000000221': <CompensacaodeHoras />,
        '1000000231': <RegistroDeHoraExtra />,
        '1000000238': <CancelamentoAlteracaoDeFerias />,
        '1000000249': <AtualizacaoDeDadosCadastraisSEDE />,
        '1000000251': <AtualizacoesDosDadosCadastraisMedicos />,
        '1000000253': <AtualizacaoDeDadosCadastraisSaudeIndigena />,
        '1000000260': <LevantamentoDeStatusVacinal />,
        '1000000307': <CATComunicacaoDeAcidenteDeTrabalho />,
      }

      const Component = possibleComponents[formId as string]

      if (Component) return Component

      if (
        formId == '1000000046' /* Admissão Administrativo AgSUS - PRAZO DETERMINADO */ ||
        formId == '1000000136' /* Admissão saude indigena - PRAZO DETERMINADO */ ||
        formId == '1000000154' /* Pré-Contratação DSEI e CASAI */ ||
        formId == '1000000228' /* Admissão saúde indígena - EXPERIÊNCIA */ ||
        formId == '1000000225' /* Admissão Administrativo AgSUS - PRAZO INDETERMINADO */ ||
        formId == '1000000294' /* Admissão Administrativo AgSUS - CARGO DE CONFIANÇA */ ||
        formId == '1000000298' /* Admissão Médicos de Família e Comunidade */ ||
        formId == '1000000302' /* Admissão Projetos - PRAZO INDETERMINADO */ ||
        formId == '1000000315' /* Admissão saude indigena - PRAZO DETERMINADO */ ||
        formId ==
          '1000000331' /* Admissão Bolsistas - Projeto de ensino, pesquisa, extensão, tecnologia e inovação da AgSUS */ ||
        formId == '1000000361' /* Admissão Administrativo AgSUS - Jovem Aprendiz */ ||
        formId == '1000000342' /* Admissão Bolsistas - Projeto Plataforma de Apoio à Gestão do Trabalho para o SUS */ ||
        formId ==
          '1000000346' /* Admissão Bolsistas - Projeto FormAgSUS – Rede Colaborativa de Ensino e Pesquisa da AgSUS */ ||
        formId == '1000000350' /* Admissão Bolsistas - Projeto FormAgSUS – Painel de Especialistas */ ||
        formId == '1000000354' /*Admissão Bolsistas - Projeto FormAgSUS – DataSUS */
      ) {
        return <AdmissãoPadraoAGSUSPrazoDeterminado />
      }

      if (formId == '1000000337' || formId == '1000000339') {
        return <SolicitacaoDeGratificacaoPorTitulacaoEspecializacao />
      }

      const foundDaily = questions.find(
        (element) => element.title == 'Trecho 1- Destino é capital ou demais localidades?'
      )

      if (foundDaily) return <CalculoDeDiariasDoAGSUS />

      const foundDependents = questions.find((element) => element.title == 'Dependente 1 - Nome completo')

      if (foundDependents) return <DependentesDoAGSUS />
    }

    return (
      <>
        {questions.map((question, index) => (
          <CustomFormViewerQuestion
            key={index}
            index={index}
            questionsLength={questions.length}
            question={question}
            disabled={false}
          />
        ))}
      </>
    )
  }, [formId])

  const onFormSubmit = async (formValues: { form_answers: KeyString }) => {
    const { getQuestionsByGambiarra } = setGambiarra({ formId, questions, formMethods })
    const formatedQuestions = await getQuestionsByGambiarra()

    const questionErrors = await validateQuestionValues({
      formQuestions: formatedQuestions,
      questionValues: formValues.form_answers,
    })

    if (questionErrors.length === 0) {
      onSubmit(formValues)
    } else {
      toast.warning(`${questionErrors.length} questões estão incorretas!`)
      setQuestionErrors(questionErrors)
    }
  }

  if (!questions) return null

  return (
    <Flex as="form" id="custom-form" direction="column" gap={2} onSubmit={formMethods.handleSubmit(onFormSubmit)}>
      {RenderComponentGambiarraByFormId}
    </Flex>
  )
}
